import { QueryClient } from "@tanstack/react-query";
import { useMemo } from "react";

import { showsBillingActionBlockedModalAtom, store } from "@/utils/atoms";
import { isBillingActionBlockedError } from "@/utils/billingActionBlockedError";
import { shouldSuppressErrorNotification } from "@/utils/sessionExpiryError";

export const useQueryClient = (
  handleError: (err: unknown, errorMessage?: string) => void,
) => {
  const queryClient = useMemo(() => {
    const onError = (err: unknown) => {
      if (isBillingActionBlockedError(err)) {
        store.set(showsBillingActionBlockedModalAtom, true);

        return;
      }

      if (!shouldSuppressErrorNotification(err)) {
        handleError(err);
      }
    };

    return new QueryClient({
      defaultOptions: {
        queries: { onError, retry: false },
        mutations: { onError },
      },
    });
  }, [handleError]);

  return queryClient;
};
